<template>
  <mp-modal size="xl" is-centered :is-open="isOpen" :on-close="close">
    <mp-modal-content max-width="780px">
      <mp-modal-header>Create goal</mp-modal-header>
      <mp-modal-close-button />
      <mp-modal-body p="10" pb="5">
        <mp-text align="center" font-size="2xl" font-weight="semibold" mb="6">Select the goal type </mp-text>

        <mp-flex gap="6" mt="4">
          <mp-box
            v-for="item in $store.state.goals.goalTypes"
            :key="item.value"
            :data-qa="`view-goal-component-modal-goal-type-option-${item.value}`"
            class="adjustable-radio"
            flex="1 1 0"
            position="relative"
          >
            <input :id="`goal-type-${item.value}`" v-model="selectedGoalType" name="goal_type" type="radio" :value="item.value" />
            <label :for="`goal-type-${item.value}`" :set="(isChecked = selectedGoalType === item.value)">
              <mp-box p="6" align="center" cursor="pointer" border="1px" border-radius="md" :border-color="isChecked ? 'blue.500' : 'gray.100'">
                <mp-icon :name="item.icon" :variant="isChecked ? 'duotone' : 'outline'" width="56px!important" height="56px!important" mb="7" />
                <mp-box :font-weight="isChecked ? 'semibold' : 'normal'">{{ item.name }}</mp-box>
              </mp-box>
            </label>
          </mp-box>
        </mp-flex>

        <mp-banner v-if="!isAllowedGoalType" mt="3" px="4" py="3" variant="warning" display="flex" align-items="center">
          <mp-banner-icon />
          <mp-banner-description> {{ selectedType.name }} goal only for high level job position. </mp-banner-description>
        </mp-banner>

        <mp-text color="gray.600" mt="3">
          <mp-text display="inline-block" font-weight="600">{{ selectedType.name }} goals</mp-text> {{ selectedType.title }}
        </mp-text>

        <mp-flex mt="8" justify-content="flex-end">
          <mp-button data-qa="modal-goal-type-btn-cancel" variant="ghost" margin-right="3" @click="close">Cancel</mp-button>
          <mp-button
            data-qa="modal-goal-type-btn-create"
            :is-disabled="isLoadingPermission || isLoadingOwner || !isAllowedGoalType"
            :is-loading="isLoadingPermission || isLoadingOwner"
            @click="createGoal"
            >Create goal</mp-button
          >
        </mp-flex>
      </mp-modal-body>
    </mp-modal-content>
    <mp-modal-overlay />
  </mp-modal>
</template>

<script>
import { alertMixin } from '@/mixins/general';

export default {
  name: 'ModalGoalType',
  mixins: [alertMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoadingPermission: false,
      isLoadingOwner: false,
      allowedGoalTypes: {
        '1': 'Individual',
        '2': 'Team',
        '3': 'Organization',
        '4': 'Company',
      },
      selectedGoalType: 1,
    };
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.getGoalPermission();
        this.selectedGoalType = this.$store.state.goals.selectedGoalType;
      }
    },
  },
  computed: {
    selectedType() {
      return this.$store.state.goals.goalTypes.find(e => e.value === this.selectedGoalType);
    },
    isAllowedGoalType() {
      return !!this.allowedGoalTypes[this.selectedGoalType];
    },
  },
  methods: {
    close() {
      this.$emit('update:isOpen', false);
      this.$emit('close');
    },
    async getGoalPermission() {
      this.isLoadingPermission = true;
      try {
        const { goal_type } = await this.$store.dispatch('goals/getGoalType'); // eslint-disable-line camelcase
        this.allowedGoalTypes = goal_type; // eslint-disable-line camelcase
      } catch (err) {
        this.alertToast(err, 'danger');
        this.allowedGoalTypes = {};
      } finally {
        this.isLoadingPermission = false;
      }
    },
    createGoal() {
      this.$store.state.goals.selectedGoalType = this.selectedGoalType;
      this.$router.push({ name: 'goals_create' });
      this.close();
    },
  },
};
</script>
